import * as React from "react"
import { Svg } from "styleguide/components"
import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconCaseStudy = ({
  title = "CaseStudy",
  color = "black",
  viewBoxWidth = 24,
  viewBoxHeight = 24,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, color, ...otherProps }}>
    <g
      id="CaseStudy"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M16.8718878,2 L20,5 L20,20 C20,21.1045695 19.1045695,22 18,22 L6,22 C4.8954305,22 4,21.1045695 4,20 L4,4 C4,2.8954305 4.8954305,2 6,2 L16.8718878,2 Z M16,4 L7.5,4 C7.25454011,4 7.05039163,4.17687516 7.00805567,4.41012437 L7,4.5 L7,19.5 C7,19.7454599 7.17687516,19.9496084 7.41012437,19.9919443 L7.5,20 L17.5,20 C17.7454599,20 17.9496084,19.8231248 17.9919443,19.5898756 L18,19.5 L18,6 L16,4 Z M15,10 C15.5522847,10 16,10.4477153 16,11 L16,13 C16,13.5522847 15.5522847,14 15,14 L10,14 C9.44771525,14 9,13.5522847 9,13 L9,11 C9,10.4477153 9.44771525,10 10,10 L15,10 Z"
        fill={uiColorToBaseColor(color)}
      />
    </g>
  </Svg.Icon>
)
export default IconCaseStudy
